import AddressListContainer from './containers/AddressListContainer'

export default AddressListContainer
